import type { VendorActionResultType } from '@econtractor/types';

export const vendorErrMessageKey = (errCode?: VendorActionResultType['errCode']): string | null => {
    switch (errCode) {
        case 'EMPTY_NAME':
            return 'messEmpty';
        case 'DUPLICATE_NAME':
            return 'messDuplicate';
        case 'INVALID_EMAIL':
            return 'messInvalidEmail';
        case 'IN_USE':
            return 'messInUse';
        case 'NOT_FOUND':
        case 'ALREADY_HIDDEN':
            return 'messNotFound';
        default:
            return null;
    }
};
